import axios from 'axios';

export default axios.create({
    baseURL: 'https://sys.immi.shop/public/shopapi'
});
